document.addEventListener('DOMContentLoaded', function () {
  
  const allFilters = document.querySelectorAll('.facets__form-vertical .js-filter');
  const facetsLayout = document.querySelector('.facets__display-vertical');
  const element = document.querySelector('.facets__form-vertical');
  
  if (!isAnyParentHidden(element)) {
  // Close other filters when one opens
  allFilters.forEach((filter) => {
    filter.addEventListener('toggle', function () {
      if (filter.open) {
        allFilters.forEach((otherFilter) => {
          if (otherFilter !== filter) {
            otherFilter.removeAttribute('open');
          }
        });
      }
    });
  });

  // Close all filters when clicked outside facets-layout
  document.addEventListener('click', function (event) {
    if (!facetsLayout.contains(event.target)) {
      allFilters.forEach((filter) => {
        if (filter.open) {
          filter.removeAttribute('open');
        }
      });
    }
  });
}
function isAnyParentHidden(elem) {
  while (elem) {
    const style = getComputedStyle(elem);
    if (style.display === 'none') return true;
    elem = elem.parentElement;
  }
  return false;
}

});
